import { render, staticRenderFns } from "./CommunityReminderDetails.vue?vue&type=template&id=90b3effa&scoped=true&"
import script from "./CommunityReminderDetails.vue?vue&type=script&lang=js&"
export * from "./CommunityReminderDetails.vue?vue&type=script&lang=js&"
import style0 from "./CommunityReminderDetails.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CommunityReminderDetails.vue?vue&type=style&index=1&id=90b3effa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90b3effa",
  null
  
)

export default component.exports